<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.5332 13.5625H13.043V21H9.72266V13.5625H7V10.5078H9.72266V8.15039C9.72266 5.49414 11.3164 4 13.7402 4C14.9023 4 16.1309 4.23242 16.1309 4.23242V6.85547H14.7695C13.4414 6.85547 13.043 7.65234 13.043 8.51562V10.5078H15.998L15.5332 13.5625Z"
			fill="currentColor"
		/>
	</svg>
</template>
